import { LoadingButton } from '@mui/lab';
import { Alert, Container, Paper, TextField, Typography } from '@mui/material';
import { FirebaseError } from 'firebase/app';
import { UserCredential, signInWithEmailAndPassword } from 'firebase/auth';
import { FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/Loading';
import { auth } from '../firebaseSetup';
import { Paths } from '../routes/paths';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage(null);

    signInWithEmailAndPassword(auth, email, password)
      .then(handleLogin)
      .catch(handleError);
  };

  const handleError = (error: FirebaseError) => {
    setIsSubmitting(false);
    setErrorMessage(error.message);
    console.error('Error logging in:', error.message);

    switch (error.code) {
      case 'auth/invalid-email':
        setErrorMessage('Neplatný email');
        break;
      case 'auth/invalid-password':
        setErrorMessage('Neplatné heslo');
        break;
      case 'auth/missing-password':
        setErrorMessage('Chybějící heslo');
        break;
      case 'auth/invalid-credential':
        setErrorMessage('Neplatné přihlašovací údaje');
        break;
      case 'auth/internal-error':
        setErrorMessage('Interní chyba serveru');
        break;
      default:
        setErrorMessage('Chyba při přihlášení');
    }
  };

  const handleLogin = (credential: UserCredential) => {
    const user = credential.user;
    console.info('User logged in:', user.email);
    navigate(Paths.Root);
  };

  useEffect(() => {
    auth.authStateReady().then(() => {
      setLoading(false);
      const user = auth.currentUser;
      if (user) navigate(Paths.Root);
    });
  }, [navigate]);

  return loading ? (
    <Loading />
  ) : (
    <Container maxWidth="xs" className="LoginContainer">
      <form onSubmit={handleSubmit}>
        <Paper>
          <Typography variant="h4">Přihlášení</Typography>
          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
          <TextField
            required
            type="email"
            placeholder="Email"
            id="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <TextField
            required
            type="password"
            placeholder="Heslo"
            id="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          <LoadingButton
            variant="contained"
            type="submit"
            loading={isSubmitting}
          >
            Přihlásit
          </LoadingButton>
        </Paper>
      </form>
    </Container>
  );
};

export default Login;
